// extracted by mini-css-extract-plugin
export default {"base":"image_base__V3Qqu","marginAuto":"image_marginAuto__gDTX7"};